import { useEffect, useState } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import * as utils from "app/components/filters-bar/utils";

type WebSourceEntity = {
    id: string;
    text: string;
    icon: string;
    disabled: boolean;
    available: boolean;
};

export const useWebSources = () => {
    const [availableWebSources, setAvailableWebSources] = useState<WebSourceEntity[]>([]);

    const { params, state } = useCurrentStateAndParams();

    useEffect(() => {
        const webSources = utils.getAvailableWebSource(state, params);
        setAvailableWebSources(webSources);
    }, []);

    return { availableWebSources };
};
